<template>
  <div>
    <section class="content-header">
      <h1>Packages</h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item active">Available Plans</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div
          v-for="(item, index) in tableData"
          :key="index"
          class="col-md-4 col-xl-4 col-sm-6 col-xs-12"
        >
          <div
            class="
              box
              text-center
              p-50
              bg-hexagons-dark
              pull-up
              plan__container
              box-outline-success
            "
          >
            <img
              :src="'/images/icons/' + item.code + '.png'"
              alt
              class="plan__badge"
            />
            <div class="box-body">
              <br />
              <h4 class="text-yellow">
                {{ item.name }}
              </h4>
              <br />
              <h2 class="font-weight-bold text-white font-size-30">
                ${{ item.price }} USD
              </h2>
              <small>One Time Payment</small>
              <hr />
              <template v-if="item.description.split('//').length > 0">
                <p v-for="x in item.description.split('//')" :key="x">
                  <strong>{{ x }}</strong>
                </p>
              </template>
              <br />
              <br />

              <button
                v-if="!loading"
                class="btn btn-block font-weight-bold"
                :class="(isUpgrade(item.price) && 'btn-success') || 'text-dark'"
                @click.prevent="createInvoice(item.code, isUpgrade(item.price))"
              >
                <template v-if="isUpgrade(item.price)"> UPGRADE NOW </template>
                <template v-else> BUY NOW </template>
                <i
                  :class="
                    (isUpgrade(item.price) && 'icon-rocket') || 'icon-energy'
                  "
                ></i>
              </button>
              <button v-else class="btn btn-block font-weight-bold" disabled>
                Loading
                <i class="fa fa-spinner fa-spin"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <invoice-payment></invoice-payment>
  </div>
</template>

<style scoped>
.plan__container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.plan__badge {
  position: absolute;
  top: -50px;
  width: 100px;
}
</style>

<script>
import Vue from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";

import { serverBus } from "@/main";
import InvoicePayment from "@/components/InvoicePayment";

Vue.component(VueQrcode.name, VueQrcode);

export default {
  data() {
    return {
      loading: false,
      modal: false,
      tableData: []
    };
  },
  components: {
    InvoicePayment
  },
  created() {
    this.getData();
    this.last_subs = this.$store.getters.currentUser.last_subs;
  },
  methods: {
    isUpgrade(planPrice) {
      let result =
        this.$store.getters.currentUser.last_subs &&
        this.$store.getters.currentUser.last_subs.subscription_status ===
          "active" &&
        Number(this.$store.getters.currentUser.last_subs.plan.price) <
          Number(planPrice);
      return result;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onCopy() {
      this.$toasted.show("Copied to clippboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true
      });
    },
    createInvoice(code, is_upgrade = false) {
      serverBus.$emit("invoicePaymentModal", {
        code: code,
        is_upgrade: is_upgrade
      });
    },
    getData() {
      this.loading = true;
      this.$http
        .get("/api/v1/client/plans", {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken
          }
        })
        .then((response) => {
          this.loading = false;
          this.tableData = response.data;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true
              });
            });
          this.loading = false;
        });
    },
    close() {
      this.modal = false;
    }
  }
};
</script>
